"use client";

import { useNavigate, useParams } from "react-router-dom";
import AmountWithCurrencyInput from "components/form/amount-currency";
import { FormColumns, FormLabel } from "components/form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import ButtonWithLoading from "@/components/button-with-loading";
import { Form } from "react-crud-form";
import { PermissionGate } from "permissions/components/gate";
import classNames from "classnames";
import { fixedJobConfigSchema } from "@/modules/work/jobs/config/fixed/schema";
import { useForm } from "react-hook-form";
import { useHotkeys } from "react-hotkeys-hook";
import { useCreateFixedConfig, useUpdateFixedConfig } from "@/modules/work/jobs/config/fixed/mutation";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormActions } from "components/form/actions";
import { PermissionControlledInput } from "permissions/components/input";
import { Input } from "ui/components/input";

const FixedConfigForm = ({ config }) => {
  const navigate = useNavigate();

  const { jobId } = useParams();

  const form = useForm({
    resolver: zodResolver(fixedJobConfigSchema),
    defaultValues: config || {},
  });
  const createMutation = useCreateFixedConfig();
  const updateMutation = useUpdateFixedConfig();

  const handleCreate = async ({ values }) => {
    await createMutation.mutateAsync({
      jobId,
      values,
    });

    navigate(-1); // optional
  };

  const handleUpdate = async (id, context) => {
    const { dirtyValues } = context;
    await updateMutation.mutateAsync({
      id,
      values: dirtyValues,
    });
    navigate(-1);
  };

  return (
    <Form
      form={form}
      create={handleCreate}
      update={handleUpdate}
      itemId={config?.id || "+"}
    >
      {({ isCreating, createItem, isUpdating, updateItem, isDirty, isNewItem }) => {
        useHotkeys(
          "ctrl+s, cmd+s",
          (event) => {
            event.preventDefault();
            if (isNewItem) {
              createItem();
            } else {
              updateItem();
            }
          },
          { preventDefault: true },
        );
        return (
          <div className={classNames("p-6 max-w-md space-y-4")}>
            <AmountWithCurrencyInput
              form={form}
              amountKey="amount"
              amountLabel="Amount"

              collection="fixed_job_config"
              isNewItem={isNewItem}
            />

            <FormActions
              rule={isNewItem ? "create:SC,AM" : "update:SC,AM"}
              collection="fixed_job_config"
              isNewItem={isNewItem}
              isCreating={isCreating}
              isUpdating={isUpdating}
              createItem={createItem}
              updateItem={updateItem}
              isDirty={isDirty}
            />
          </div>
        );
      }}
    </Form>
  );
};

export default FixedConfigForm;
